import { render, staticRenderFns } from "./ctcTemplate.vue?vue&type=template&id=403c658a"
import script from "./ctcTemplate.vue?vue&type=script&lang=js"
export * from "./ctcTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports